import { Link, type ReactNode } from "react-router-dom";

type Props = {
  children?: ReactNode;
  right?: ReactNode;
};

export function SiteHeader({ children, right }: Props) {
  return (
    <header className="site-header">
      <div className="site-header__inner">
        <Link className="site-header__brand" to="/">
          <span>bezpart</span> Board
        </Link>
        <nav className="site-header__nav">
          {children}
          {right}
        </nav>
      </div>
    </header>
  );
}
